import {
  describeSchemaProblem,
  schemaProblems,
} from '../employment/lib/schemaProblems'

import { isEmploymentHistoryCovered } from './employmentHistoryCoverage'
import { filterPrivateQuestionResponses } from './questionResponses'
import {
  questionValuesFromResponses,
  validateQuestionValues,
} from './questionValidation'
import {
  buildAccidentsPayload,
  buildAddressesPayload,
  buildEmploymentPayload,
  buildEquipmentPayload,
  buildLicensePayload,
  buildPersonalDetailsPayload,
} from './stepPayloads'
import { findStepErrors } from './validators'

export type SectionKey =
  | 'personal'
  | 'addresses'
  | 'license'
  | 'equipment'
  | 'accidents'
  | 'employment'
  | 'questions'

export type SectionIssues = Record<SectionKey, string[]>

export const sectionPayloads = (values): Record<SectionKey, object[]> => ({
  personal: [buildPersonalDetailsPayload(values)],
  addresses: [buildAddressesPayload(values)],
  license: [buildLicensePayload(values)],
  equipment: [buildEquipmentPayload(values)],
  accidents: [buildAccidentsPayload(values)],
  employment: [buildEmploymentPayload(values)],
  questions: [],
})

export const checkSections = (
  values,
  application,
  now: Date = new Date()
): SectionIssues => {
  const payloads = sectionPayloads(values)
  const issues = Object.fromEntries(
    Object.entries(payloads).map(([key, list]) => [
      key,
      list.flatMap((payload) => Object.values(findStepErrors(values, payload))),
    ])
  ) as SectionIssues

  schemaProblems(values.employmentExperiences ?? []).forEach((problem) =>
    issues.employment.push(describeSchemaProblem(problem))
  )
  const minYears =
    application?.applicant?.jobListing?.minEmploymentHistoryYears ?? null
  if (
    !isEmploymentHistoryCovered(
      buildEmploymentPayload(values).employmentExperiences,
      minYears,
      now
    )
  ) {
    issues.employment.push(
      `Please account for your employment history for the last ${minYears} years, including any periods of unemployment.`
    )
  }

  const privateQuestions = filterPrivateQuestionResponses(
    application?.questionResponses
  )
  issues.questions = Object.values(
    validateQuestionValues(
      privateQuestions,
      questionValuesFromResponses(privateQuestions)
    )
  )

  return issues
}
